<template>
  <div class="h-screen flex flex-col bg-pitch-black text-total-white">
    <!-- Header Section -->
    <TopNavbar
      :isThread="true"
      :userRole="userRole"
      :projectId="project?.id"
      :isSimulation="project?.is_simulation"
      :projectName="project?.address_1"
    />
    <div class="overflow-y-auto">
      <div class="flex w-full justify-between items-center px-4 py-4 mt-2 bg-pitch-black">
        <a
          @click="goBack"
          class="text-prime-golden text-base font-medium flex items-center"
        >
          <img
            class="w-6 h-6 inline mr-2"
            src="@/assets/images/left-chevron.svg"
            alt="Back"
          />
        </a>
        <h1 class="text-2xl mr-4">
          <span
            class="underline text-prime-golden"
            @click="openContactProfile(mainMessageData?.from_contact_stakeholder?.id)"
            >{{ mainMessageData?.from_contact_stakeholder?.first_name || "..." }}
          </span>
          &
          <span
            class="text-prime-golden underline"
            @click="openContactProfile(mainMessageData?.to_contact_stakeholders?.[0]?.id)"
            >{{ getFirstNameOrNumber(mainMessageData?.to_contact_stakeholders?.[0]) }}
          </span>
        </h1>
        <span></span>
      </div>

      <!-- Call Details -->
      <div class="py-4 bg-pitch-black min-w-[80vw]">
        <div
          class="grid grid-rows-3 px-4 gap-4 justify-center items-center mb-8 min-w-[80vw]"
        >
          <div
            class="grid grid-cols-2 text-left justify-between min-w-[70vw] md:min-w-auto"
          >
            <p class="text-sm font-semibold">Date</p>
            <p>{{ getDate() }}</p>
          </div>
          <div class="grid grid-cols-2 items-center text-left justify-between">
            <p class="text-sm font-semibold">Start Time</p>
            <p>{{ getTime() }}</p>
          </div>
          <div class="grid grid-cols-2 items-center text-left justify-between">
            <p class="text-sm font-semibold">Duration</p>
            <p>{{ getCallDuration() }}</p>
          </div>
        </div>

        <!-- Participants -->
        <!-- <div class="my-4 px-4">
          <h3 class="text-base py-2 text-total-white-500 font-semibold">Participants</h3>
          <div class="flex items-center justify-around space-x-4 mt-2">
            <div class="flex items-center">
              <div
                class="w-8 h-8 rounded-full flex items-center justify-center bg-light-grey-translucent-dark border border-light-grey-translucent-dark overflow-hidden"
              >
                <template v-if="''">
                  <img :src="''" alt="Profile Image" class="w-full h-full rounded-full" />
                </template>
                <template v-else>
                  <i class="fa-solid fa-user text-2xl mt-auto text-pitch-black"></i>
                </template>
              </div>
              <p class="ml-2">{{ messages[0]?.from_contact_stakeholder?.first_name }} {{ messages[0]?.from_contact_stakeholder?.last_name }}</p>
              <i class="fas fa-external-link-alt ml-2 text-prime-golden"></i>
            </div>
            <div class="flex items-center">
              <div
                class="w-8 h-8 rounded-full flex items-center justify-center bg-light-grey-translucent-dark border border-light-grey-translucent-dark overflow-hidden"
              >
                <template v-if="''">
                  <img :src="''" alt="Profile Image" class="w-full h-full rounded-full" />
                </template>
                <template v-else>
                  <i class="fa-solid fa-user mt-auto text-2xl text-pitch-black"></i>
                </template>
              </div>
              <p class="ml-2">{{ mainMessageData?.to_contact_stakeholders?.[0]?.first_name }} {{ mainMessageData?.to_contact_stakeholders?.[0]?.last_name }}</p>
              <i class="fas fa-external-link-alt ml-2 text-prime-golden" @click="openContactProfile(mainMessageData?.to_contact_stakeholders?.[0]?.id)"></i>
            </div>
          </div>
        </div> -->

        <!-- Conversation Summary -->
        <div class="my-4 px-4">
          <h3 class="text-base py-4 pt-8 font-semibold text-total-white-800">Summary</h3>
          <p class="text-sm text-left md:text-center font-semibold px-2">
            {{ summary || "No summary available" }}
          </p>
        </div>

        <!-- Recording Download -->
        <div class="my-4 px-4">
          <h3 class="text-base py-4 pt-8 font-semibold text-total-white-800">
            Call Recording
          </h3>
          <div class="flex justify-center mt-2">
            <audio controls class="w-full max-w-4xl" preload="auto">
              <source :src="recordingUrl" type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
            <a
              :href="recordingUrl"
              target="_blank"
              class="text-prime-golden text-lg font-medium font-avenir flex items-center ml-4"
            >
              <img
                class="w-6 h-6 inline mr-2"
                src="@/assets/images/download.svg"
                alt="Download"
              />
            </a>
          </div>
        </div>

        <!-- Raw Transcript -->
        <div class="my-6">
          <div class="border-t border-dark-grey my-4"></div>
          <h3 class="text-base px-4 text-total-white-500 py-2 pb-8 font-semibold">
            Transcript
          </h3>

          <!-- Single Message -->
          <div
            v-for="message in messages"
            :key="message.id"
            class="mb-6 border-b px-4 pb-8 flex flex-col items-start border-dark-grey"
          >
            <div
              v-if="message.from_contact_stakeholder?.id == callerId"
              class="flex items-start px-2 md:w-96 mb-2"
            >
              <div class="text-left">
                <div class="flex justify-between items-end space-x-2">
                  <div class="flex items-end space-x-2">
                    <div
                      class="w-8 h-8 flex-shrink-0 rounded-full flex items-center justify-center bg-light-grey-translucent-dark border border-light-grey-translucent-dark overflow-hidden"
                    >
                      <template
                        v-if="message.from_contact_stakeholder?.profile_image_url"
                      >
                        <img
                          :src="message.from_contact_stakeholder?.profile_image_url"
                          alt="Avatar"
                          class="w-full h-full rounded-full"
                        />
                      </template>
                      <template v-else>
                        <i class="fa-solid fa-user mt-auto text-2xl text-pitch-black"></i>
                      </template>
                    </div>

                    <p class="font-semibold">
                      {{ message.from_contact_stakeholder?.first_name }}
                      {{ message.from_contact_stakeholder?.last_name }}
                    </p>
                  </div>
                </div>
                <p class="text-sm pt-2 leading-relaxed mt-2">{{ message.content }}</p>
                <p class="text-xs text-total-white-500 mt-2">
                  {{ formatDateTime(message.date_time_created) }}
                </p>
              </div>
            </div>

            <div v-else class="flex items-end px-2 w-full justify-end mb-2">
              <div class="text-right">
                <div class="flex justify-between items-end space-x-2">
                  <div class="flex items-end space-x-2 w-full justify-end">
                    <p class="font-semibold">
                      {{ message.from_contact_stakeholder?.first_name }}
                      {{ message.from_contact_stakeholder?.last_name }}
                    </p>
                    <div
                      class="w-8 h-8 flex-shrink-0 rounded-full flex items-center justify-center bg-light-grey-translucent-dark border border-light-grey-translucent-dark overflow-hidden"
                    >
                      <template
                        v-if="message.from_contact_stakeholder?.profile_image_url"
                      >
                        <img
                          :src="message.from_contact_stakeholder?.profile_image_url"
                          alt="Avatar"
                          class="w-full h-full rounded-full"
                        />
                      </template>
                      <template v-else>
                        <i class="fa-solid fa-user mt-auto text-2xl text-pitch-black"></i>
                      </template>
                    </div>
                  </div>
                </div>
                <p class="text-sm pt-2 leading-relaxed mt-2 w-full justify-end">
                  {{ message.content }}
                </p>
                <p class="text-xs text-total-white-500 mt-2">
                  {{ formatDateTime(message.date_time_created) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="p-4 text-center text-xs text-total-white-500 mb-20">
        call ended at {{ getCallEndTime() }}
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from "@/components/TopNavbar.vue";
import { useRoute, useRouter } from "vue-router";
import { useLogStore } from "@/stores/log";
import { ref, onMounted } from "vue";
import { useUserStore } from "@/stores/user";
import { useProjectStore } from "@/stores/project";
import { computed } from "vue";

export default {
  components: {
    TopNavbar,
  },
  data() {
    return {
      messages: [
        {
          id: 1,
          sender: "Test Name",
          time: "7:34PM",
          text: `Mauris fermentum dui vel odio blandit, et faucibus turpis elementum. Nam volutpat orci ut lorem convallis, id dignissim odio suscipit.`,
          avatar: "",
        },
        {
          id: 2,
          sender: "Test Name",
          time: "7:34PM",
          text: `Suspendisse nec ligula auris fermentum dui vel odio blandit, et faucibus turpis elementum. Nam volutpat orci ut lorem convallis, id dignissim odio suscipit.`,
          avatar: "",
        },
        {
          id: 3,
          sender: "Test Name",
          time: "7:34PM",
          text: `Suspendisse nec ligula auris fermentum dui vel odio blandit, et faucibus turpis elementum. Nam volutpat orci ut lorem convallis, id dignissim odio suscipit.`,
          avatar: "",
        },
      ],
    };
  },
  setup() {
    // Get the last log content from the route query
    const route = useRoute();

    const router = useRouter();

    const logStore = useLogStore();
    const userStore = useUserStore();
    const projectStore = useProjectStore(); // Instantiate the store correctly

    const userRole = computed(() => userStore.profile?.account_type);
    const project = computed(() => projectStore.currentProject);

    const summary = ref("");

    const messages = ref([]);

    const recordingUrl = ref("");

    const mainMessageData = ref({});

    const callerId = ref(null);

    const callStartTime = ref(null);

    const callEndTime = ref(null);

    const callDuration = ref(null);

    onMounted(async () => {
      await logStore.fetchMessagesByThreadId(Number(route.params.threadId));
      messages.value = logStore.threadMessages;
      mainMessageData.value = logStore.threadMessages?.[0];

      callerId.value = logStore.threadMessages?.[0].from_contact_stakeholder.id;

      const startTime = mainMessageData.value?.call_start_time;
      const endTime = mainMessageData.value?.call_end_time;

      callStartTime.value = startTime;
      callEndTime.value = endTime;

      summary.value =
        logStore.threadMessages?.[logStore.threadMessages.length - 1].subject;

      recordingUrl.value =
        logStore.threadMessages?.[logStore.threadMessages.length - 1].media_urls?.[0];

      callDuration.value = (new Date(endTime) - new Date(startTime)) / 1000; // convert to seconds

      console.log("callDuration", callDuration.value);
    });

    const getDate = () => {
      const timestamp = mainMessageData.value?.date_time_created;

      if (!timestamp) return "";

      const date = new Date(timestamp);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        weekday: "short",
        month: "long",
        day: "numeric",
      });
    };

    const getTime = () => {
      const timestamp = mainMessageData.value?.call_start_time;
      if (!timestamp) return "";

      const date = new Date(timestamp);
      return (
        date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }) + " PST"
      );
    };

    const getCallEndTime = () => {
      const timestamp = mainMessageData.value?.call_end_time;
      if (!timestamp) return "";

      const date = new Date(timestamp);
      return (
        date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }) + " PST"
      );
    };

    const getCallDuration = () => {
      const hours = Math.floor(callDuration.value / 3600);
      const minutes = Math.floor((callDuration.value % 3600) / 60);
      const seconds = callDuration.value % 60;
      let duration = `${seconds} secs`;
      if (minutes > 0) duration = `${minutes} mins ${duration}`;
      if (hours > 0) duration = `${hours} hrs ${duration}`;
      return duration;
    };

    const openContactProfile = (id) => {
      router.push({
        name: "ContactViewPage",
        params: { id },
        query: {
          from_call: true,
          threadId: route.params.threadId,
          projectId: route.query.projectId,
        },
      });
    };

    const getFirstNameOrNumber = (participant) => {
      if (participant?.first_name == "" || participant?.first_name == "Unknown") {
        return participant?.phone;
      }
      return participant?.first_name;
    };

    return {
      messages,
      mainMessageData,
      getDate,
      getTime,
      callerId,
      openContactProfile,
      callDuration,
      getCallDuration,
      callEndTime,
      getCallEndTime,
      summary,
      recordingUrl,
      getFirstNameOrNumber,
      project,
      userRole,
    };
  },
  methods: {
    goBack() {
      if (this.$route.params.fromFiles) {
        this.$router.push({
          name: "ProjectPage",
          query: { tab: "files" },
        });
      } else {
        this.$router.push({
          name: "ProjectPage",
          query: { tab: this.$route.query.tab, readLogs: this.$route.query.readLogs },
        });
      }
    },
    editLog() {
      console.log("Edit log clicked");
    },
    shareLog() {
      console.log("Share log clicked");
    },
    formatDateTime(date_time_created) {
      const date = new Date(date_time_created);
      return `${date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })} at ${date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
      })} PST`;
    },
  },
};
</script>

<style scoped>
/* Custom styles if needed */
</style>
